import { useQueries } from "@tanstack/react-query";
import { getGuideIcon } from "../api";
import { useContentfulClient } from "../ContentfulClientProvider";

/**
 * @param icon - icon names for the specific guided flows
 * @returns map of icon name to url for the guide icon
 * @description This hook fetches the guide icon url from Contentful using the name of the icon. It uses react-query to manage the data fetching and caching.
 * The icon is cached indefinitely (staleTime: Infinity) to avoid unnecessary network requests.
 */
export const useGuideIcons = (icons: string[]): Map<string, string | undefined> => {
    const contentfulClient = useContentfulClient();

    const iconDataArray = useQueries({
        queries: icons.map((icon) => ({
            queryKey: [icon],
            queryFn: async () => await getGuideIcon(contentfulClient, icon),
            staleTime: Infinity,
        })),
    })
        .map((iconData) => iconData.data)
        .filter((iconData) => iconData !== undefined);

    return new Map(iconDataArray.map((data) => [data.icon, data.url]));
};
